import { render, staticRenderFns } from "./auto-after-search-serial.vue?vue&type=template&id=54698b68"
import script from "./auto-after-search-serial.vue?vue&type=script&lang=js"
export * from "./auto-after-search-serial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports